"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
exports.__esModule = true;
var react_1 = __importStar(require("react"));
var react_konva_1 = require("react-konva");
var types_1 = require("../types");
var data_1 = require("../data");
var UrlImg_1 = __importDefault(require("./UrlImg"));
var App_1 = require("../App");
var TinyPieChart_1 = __importDefault(require("./TinyPieChart"));
var isMobile = window.innerWidth < 500;
var TimelineEvent = function (_a) {
    var index = _a.index, x = _a.x, y = _a.y, eventWidth = _a.eventWidth, event = _a.event, onEventSelected = _a.onEventSelected, pause = _a.pause, selected = _a.selected, pointedAt = _a.pointedAt;
    var _b = (0, react_1.useState)(false), hovered = _b[0], setHovered = _b[1];
    var handleClick = function (e) {
        onEventSelected(event, x, y);
    };
    var handleTap = function (e) {
        onEventSelected(event, x, y);
    };
    var handleMouseEnter = function (e) {
        setHovered(true);
        if (!pause) {
            var container = e.target.getStage().container();
            container.style.cursor = "pointer";
        }
    };
    var handleMouseLeave = function (e) {
        setHovered(false);
        var container = e.target.getStage().container();
        container.style.cursor = "default";
    };
    return (react_1["default"].createElement(react_konva_1.Group, { onClick: handleClick, onTap: handleTap, onMouseEnter: handleMouseEnter, onMouseLeave: handleMouseLeave },
        react_1["default"].createElement(react_konva_1.Rect, { x: x, y: y, width: eventWidth, height: App_1.LINE_HEIGHT + (pointedAt ? 1 : 0), fill: types_1.TYPES[event.type], stroke: "white", strokeWidth: 1 + (hovered || selected ? 1 : 0), opacity: selected ? 0.8 : 1 }),
        react_1["default"].createElement(react_konva_1.Text, { x: x + 5, y: y + (isMobile ? 4 : 10), wrap: "word", width: eventWidth - 10, text: event.shortLabel ? event.shortLabel : event.label, fill: "white", fontFamily: "Trebuchet MS", fontStyle: selected ? "italic" : "normal", fontSize: event.type == "INTERNSHIP" ? 13 : isMobile ? 14 : 15, height: App_1.LINE_HEIGHT }),
        event.type != "INTERNSHIP" && !isMobile &&
            react_1["default"].createElement(react_1["default"].Fragment, null,
                react_1["default"].createElement(UrlImg_1["default"], { x: x + eventWidth - 30, y: y + App_1.LINE_HEIGHT - 15, width: 20, src: (0, data_1.getFlagPath)(event), height: 10 }),
                react_1["default"].createElement(TinyPieChart_1["default"], { x: x + eventWidth - 50, y: y + App_1.LINE_HEIGHT - 15, percentage: event.timePercentage, radius: 5, backgroundColor: types_1.TYPES[event.type] }))));
};
exports["default"] = TimelineEvent;
